import React from 'react';

import Icon from './Icon';

class Carousel extends React.Component {
    constructor(props) {
        super(props);
        let children =  this.props.children || [];
        children =  Array.isArray(children) ?children.filter(item => item !== null) : children;
        this.state = {
            currentPaneIndex: 0,
            paneCount: children.length || 1,
        };
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handlePreviousClick = this.handlePreviousClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentPaneIndex !== undefined) {
            this.setState({
                paneCount: nextProps.children,
                currentPaneIndex: nextProps.currentPaneIndex
            }, () => this.countPanes());
        } else {
            this.setState({paneCount: nextProps.children && nextProps.children.length});
        }
    }

    countPanes() {
        let count = 0;
        React.Children.forEach(this.props.children, child => {
            if (child && child.props && child.props.className.includes('pane')) {
                count++
            }
        });

        this.setState({paneCount: count})
    }



    handlePreviousClick() {
        this.setState({currentPaneIndex: this.state.currentPaneIndex - 1});
    }

    handleNextClick() {
        this.setState({currentPaneIndex: this.state.currentPaneIndex + 1});
    }

    render() {
        let showPrevious = (this.state.paneCount > 1 && this.state.currentPaneIndex) && !this.props.hideArrowsControls;
        let showNext = (this.state.paneCount > 1 && this.state.currentPaneIndex < this.state.paneCount - 1) && !this.props.hideArrowsControls;
        return (
            <div className="carousel">
                <div className={`arrow-wrapper previous ${showPrevious && 'show'}`}>
                    <div className="arrow" onClick={() => showPrevious && this.handlePreviousClick()}>
                        <Icon type="angle-left"/>
                    </div>
                </div>
                <div className="panes-wrapper">
                    <div className="panes" style={{
                        width: `${this.state.paneCount * 100}%`,
                        marginLeft: `-${this.state.currentPaneIndex * 100}%`
                    }}>
                        {this.props.children}
                    </div>
                </div>
                <div className={`arrow-wrapper next ${showNext && 'show'}`}>
                    <div className="arrow" onClick={() => showNext && this.handleNextClick()}>
                        <Icon type="angle-right"/>
                    </div>
                </div>
            </div>
        )
    }
}

export default Carousel;
